/**
 *
 * @param {*} snHttpFactoryConfig
 * @returns A function, that when called, will create an instance of sn-http-request
 */
const createSnHttp = snHttpFactoryConfig => async () => {
	const snHttpRequest = await import('sn-http-request');
	const {snHttpFactory} = snHttpRequest;
	const snHttp = snHttpFactory(snHttpFactoryConfig);

	return snHttp;
};

export default createSnHttp;
